import { serviceUrl } from '../config/net.config'
//baseUrl2调用的是wtbu_service中的方法
import request from '@/utils/request'
// import qs from 'qs'

/**
 *  根据 id 查询毕业生档案详情
 * @param id 
 * @returns 
 */
export function queryGraduateFile(data) {
    return request({
      url: serviceUrl+'/api/wtbuGraduate/queryGraduateById?userid='+data,
      // head: 'application/json;charset=UTF-8',
      method: 'get',
      token:sessionStorage.getItem('xzztcToken')
    })
} 